import script from "./TraitRanksApesTraitsActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitRanksApesTraitsActivity.vue?vue&type=script&setup=true&lang=js"

import "./TraitRanksApesTraitsActivity.vue?vue&type=style&index=0&id=4b720d39&lang=scss"

const __exports__ = script;

export default __exports__